import {
  Card,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/Primitives/Card"
import { Text } from "@/components/Primitives/Text"
import { useConfig } from "@/hooks/useConfig"
import { useNavigate } from "react-router-dom"
import { Button } from "@/components/Primitives/Button"
import { AuthLayout } from "@/components/Primitives/AuthLayout"

export function ForgotPasswordEmailPage() {
  const { t } = useConfig()
  const navigate = useNavigate()

  return (
    <AuthLayout
      description={t("config_forgot_password_email_description")}
      imageUrl="/images/open-box.webp"
    >
      <Card>
        <CardHeader>
          <CardTitle>{t("config_sign_up_success_title")}</CardTitle>

          <Text variant="small" className="text-neutral-700">
            {t("config_forgot_password_email_body")}
          </Text>
        </CardHeader>

        <CardFooter>
          <Button
            variant="tertiary"
            className="font-semibold w-full"
            onClick={() => navigate(-1)}
          >
            Change Email
          </Button>
        </CardFooter>
      </Card>
    </AuthLayout>
  )
}
